import { FC } from "react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

interface IButtonWithIconProps {
  title: string;
  icon?: JSX.Element | string;
  onClick?: () => void;
}

const ButtonWithIcon: FC<IButtonWithIconProps> = props => {
  return (
    <ButtonContainer
      startIcon={props.icon}
      onClick={props.onClick}
      fullWidth={false}
      size="small"
    >
      {props.title}
    </ButtonContainer>
  );
};

export default ButtonWithIcon;

const ButtonContainer = styled(Button)`
  width: max-content;
  text-transform: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #838993;
  font-weight: 400;
  justify-content: start;
  color: #1e1e1e;
  svg {
    // width: 20px;
    // height: 20px;
  }
`;
